import { assign } from '@atds-legacy/lang';
import { Record } from '@redge-media/fo-js-sdk';
import favourite from '@/shared/libs/helpers/favourite';
import cover from '@/shared/libs/helpers/cover';

const Channel = Record.mixin(cover).extend({
  constructor: function Channel(attrs = {}, opts = {}) {
    Record.call(this, assign(attrs, {
      currentProgram: undefined,
      nextProgram: undefined,
      favourite: false,
    }), opts);

    assign(this, favourite(this));
  },

  get isPlaybackDisabled() {
    return !this.allowProgrammePlaybackOnAvod;
  },
});

export default Channel;
